<template>
  <MembershipOverlayCard
    :title="resolvedTitle"
    :message="resolvedMessage"
    :primary-action-label="primaryActionLabel"
    :loading="variant === 'loading'"
    :dismiss-on-backdrop="variant !== 'loading'"
    @primary="dismiss"
    @backdrop="dismiss"
  />
</template>

<script setup>
import { computed } from 'vue';
import { modalController } from '@ionic/vue';
import MembershipOverlayCard from '@/components/partner/MembershipOverlayCard.vue';

const props = defineProps({
  variant: {
    type: String,
    default: 'success',
    validator: (v) => ['success', 'highlight_success', 'error', 'loading'].includes(v),
  },
  title: { type: String, default: '' },
  message: { type: String, default: '' },
  buttonLabel: { type: String, default: '' },
});

const defaults = {
  success: {
    title: 'Kauf erfolgreich',
    message: 'Dein Partner-Paket ist aktiv. Du kannst Highlights buchen und dein Werbebudget nutzen.',
    buttonLabel: 'Premium nutzen',
  },
  highlight_success: {
    title: 'Highlight aktiv',
    message: 'Dein Highlight ist jetzt aktiv und sichtbar für Nutzer in der App.',
    buttonLabel: 'OK',
  },
  error: {
    title: 'Kauf fehlgeschlagen',
    message: 'Die Zahlung konnte nicht abgeschlossen werden. Bitte wähle eine andere Zahlungsmethode.',
    buttonLabel: 'OK',
  },
  loading: {
    title: 'Wird aktiviert…',
    message: 'Wir bestätigen deine Zahlung. Das dauert nur einen Moment.',
    buttonLabel: '',
  },
};

const resolvedTitle = computed(() => props.title || defaults[props.variant]?.title || '');
const resolvedMessage = computed(() => props.message || defaults[props.variant]?.message || '');
const primaryActionLabel = computed(() => {
  if (props.variant === 'loading') return '';
  if (props.buttonLabel) return props.buttonLabel;
  return defaults[props.variant]?.buttonLabel || 'OK';
});

const dismiss = () => modalController.dismiss(null, 'close');
</script>
